module.exports = __webpack_public_path__ + "static/perplexity-b4505cbd6300d818152a828593d21360.png";